import BioStarks from '../assets/projects/biostarks.png'
import Survey from '../assets/projects/adeebSurvery.png'
import VehicleReport from '../assets/projects/vehiclereport.me_.png'    
import BeeWell from '../assets/projects/beewellapp.com_.png' 
import YogaWithEmilia from '../assets/projects/yogawithemilia.com_.png'
import Mamus from '../assets/projects/mamus.co.uk_.png'
import LearnQuraan from '../assets/projects/www.learnquraan.co.uk_.png'
import GCCMarketing from '../assets/projects/www.gcc-marketing.com_.png'

export const data = [
  {
    id: 1,
    name: "BioStarks Results Portal",
    image: BioStarks, // add screenshot import at top
    github: "",
    live: "https://results.biostarks.com/welcome",
  },
  {
    id: 2,
    name: "Survey Project",
    image: Survey, // add screenshot import at top
    github: "https://github.com/atifdev/survey-project", // optional, update if available
    live: "https://survey-project-five.vercel.app/",
  },
  {
    id: 3,
    name: "Vehicle Report",
    image: VehicleReport, // add screenshot import at top
    github: "",
    live: "https://vehiclereport.me/",
  },
  {
    id: 4,
    name: "BeeWell App",
    image: BeeWell, // add screenshot import at top
    github: "",
    live: "https://beewellapp.com/",
  },
  {
    id: 5,
    name: "Yoga With Emilia",
    image: YogaWithEmilia, // add screenshot import at top
    github: "",
    live: "https://yogawithemilia.com/",
  },
  {
    id: 6,
    name: "Mamus UK",
    image: Mamus, // add screenshot import at top
    github: "",
    live: "https://mamus.co.uk/",
  },
  {
    id: 7,
    name: "Learn Quraan UK",
    image: LearnQuraan, // add screenshot import at top
    github: "",
    live: "https://www.learnquraan.co.uk/",
  },
  {
    id: 8,
    name: "GCC Marketing",
    image: GCCMarketing, // add screenshot import at top
    github: "",
    live: "https://www.gcc-marketing.com/",
  },
];
